import { EuiIcon, EuiFlexGroup, EuiFlexItem } from "@elastic/eui";

const NoWaitTime = () => {
  return (
    <EuiFlexGroup
      direction="column"
      alignItems="center"
      justifyContent="center"
      gutterSize="s"
      style={{ marginTop: "32px" }}>
      <EuiFlexItem grow={false}>
        <EuiFlexGroup alignItems="center" justifyContent="center" gutterSize="s">
          <EuiFlexItem grow={false}>
            <EuiIcon type="checkCircle" color={"var(--green)"} size="xl" />
          </EuiFlexItem>
          <EuiFlexItem grow={false}>
            <h2
              style={{
                fontSize: "var(--fs20)",
                fontWeight: "500",
                color: "var(--primary-color)",
                margin: 0,
              }}>
              SQL Query Success
            </h2>
          </EuiFlexItem>
        </EuiFlexGroup>
      </EuiFlexItem>
      <EuiFlexItem grow={false}>
        <p
          style={{
            fontWeight: 400,
            fontSize: "var(--fs16)",
            color: "rgb(81, 99, 129)",
            margin: 0,
            textAlign: "center",
          }}>
          Your query executed instantly with no wait time!
        </p>
      </EuiFlexItem>
    </EuiFlexGroup>
  );
};

export default NoWaitTime;
